import { PropsWithChildren } from 'react'

import { Footer } from '@/app/panel/_components/footer'
import { Header } from '@/app/panel/_components/header'
import { useNavbarContext } from '@/app/panel/_contexts/navbar-context'
import { cn } from '@/lib/utils'

type MainContentProps = PropsWithChildren

export const MainContent = ({ children }: MainContentProps) => {
  const { expanded } = useNavbarContext()

  return (
    <div
      className={cn(
        'flex w-full flex-col',
        expanded
          ? 'lg:ml-56 lg:w-[calc(100%-224px)]'
          : 'lg:ml-[6.5rem] lg:w-[calc(100%-104px)]',
      )}
    >
      <Header />

      <main className="container size-full pt-1">{children}</main>

      <Footer />
    </div>
  )
}
